import React, { useState } from 'react';
import { Button, Card, Table, Tooltip, Typography, message } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { TableColumnTitle } from '../../../../shared/globalStyling/styledText';
import { formatCurrency2SigFig, formatWholeNumberNaN } from '../../../../../core/utils/campaigns';
import TagsPagination from '../../main/components/TagsPagination';
import '../../styles/index.scss';

const { Text } = Typography;

const PageUrlActivityCard = ({ rows, loading, onRefresh }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const dataSource = (rows || []).map((row, index) => ({
    key: index,
    pageUrl: row.pageUrl,
    trTotal: row.trTotal,
    pageUrlCount: row.pageUrlCount,
  }));

  const cellStyle = { color: '#000', cursor: 'default' };

  const columns = [
    {
      title: <TableColumnTitle text={'Page URL'} />,
      dataIndex: 'pageUrl',
      key: 'pageUrl',
      ellipsis: true,
      render: (pageUrl) => <span style={cellStyle}>{pageUrl}</span>,
    },
    {
      title: <TableColumnTitle text={'Transaction Total'} />,
      dataIndex: 'trTotal',
      key: 'trTotal',
      width: 160,
      render: (trTotal) => (
        <span style={cellStyle}>
          {trTotal === null || trTotal === undefined
            ? '—'
            : formatCurrency2SigFig(trTotal)}
        </span>
      ),
    },
    {
      title: <TableColumnTitle text={'Count'} />,
      dataIndex: 'pageUrlCount',
      key: 'pageUrlCount',
      width: 100,
      render: (pageUrlCount) => (
        <span style={cellStyle}>{formatWholeNumberNaN(pageUrlCount)}</span>
      ),
    },
  ];

  return (
    <Card
      title="PAGE URL ACTIVITY"
      className="tags-card"
      extra={
        <Tooltip title="Note: Page URL activity logs data from the past 5 days only">
          <Button
            shape="round"
            type="primary"
            loading={loading}
            icon={<ReloadOutlined />}
            onClick={async () => {
              try {
                message.info('Fetching page URL activity');
                await onRefresh();
              } catch (e) {
                message.error('Failed to fetch page URL activity');
              }
            }}
          >
            Refresh
          </Button>
        </Tooltip>
      }
    >
      <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
        Page URL, transaction total and event count for sign-ups and transactions over the past 5 days.
      </Text>
      <Table
        aria-label="Page URL activity"
        dataSource={dataSource.slice((currentPage - 1) * pageSize, currentPage * pageSize)}
        columns={columns}
        scroll={{ x: 'max-content' }}
        size="middle"
        className="tags-test-logs__main-table"
        pagination={false}
        loading={loading}
        rowKey="key"
        locale={{ emptyText: 'No page URL activity. Click Refresh to fetch data.' }}
      />
      <TagsPagination
        current={currentPage}
        pageSize={pageSize}
        total={dataSource.length}
        onChange={setCurrentPage}
        onPageSizeChange={(size) => {
          setPageSize(size);
          setCurrentPage(1);
        }}
        compact
      />
    </Card>
  );
};

export default PageUrlActivityCard;
